export default "__VITE_ASSET__4ddb2d19__"